import { render, staticRenderFns } from "./SearchTrades.vue?vue&type=template&id=066de18a&scoped=true&"
import script from "./SearchTrades.vue?vue&type=script&lang=js&"
export * from "./SearchTrades.vue?vue&type=script&lang=js&"
import style0 from "./SearchTrades.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SearchTrades.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./SearchTrades.vue?vue&type=style&index=2&id=066de18a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066de18a",
  null
  
)

export default component.exports